/* eslint-disable react/display-name */
// * You should NOT edit this file directly. Read CONTRIBUTING.md for more information on creating icons
import { __assign } from "tslib";
import React from 'react';
import { forwardRef } from '../../helpers/forwardRef';
import { BaseIcon } from '../../internal/BaseIcon';
export var ArrowDCornerLeftUpIcon20Regular = forwardRef('ArrowDCornerLeftUpIcon20Regular', function (props, ref) {
    return (React.createElement(BaseIcon, __assign({ ref: ref, viewBoxSize: 20 }, props),
        React.createElement("path", { d: "M1.207 7.082a.75.75 0 1 0 1.086 1.036L6.25 3.972V14.5a3.25 3.25 0 0 0 3.25 3.25H18a.75.75 0 0 0 0-1.5H9.5a1.75 1.75 0 0 1-1.75-1.75V3.972l3.957 4.146a.75.75 0 0 0 1.085-1.036L8.629 2.72a2.25 2.25 0 0 0-3.256 0L1.207 7.082Z" })));
});
